import {useNavigate} from 'react-router-dom';
import useGetUnSeenChat from '../../../../services/hookService/getUnSeenChat/getUnSeenChat';
import {googleAnalyticsInstance} from '../../../../utilities/helper/googleAnalitics';

interface ChatHeaderIconProps {
  iconClass?: string;
  className?: string;
}

const ChatHeaderIcon: React.FC<ChatHeaderIconProps> = ({
  iconClass = 'icon-namechat text-[25px] text-gray-700',
  className = '',
}) => {
  const navigate = useNavigate();
  const {data: unSeenNotificationData} = useGetUnSeenChat();

  const hasUnseenMessages =
    unSeenNotificationData !== undefined &&
    unSeenNotificationData !== null &&
    unSeenNotificationData.unseen_count !== 0;

  const handleClick = () => {
    navigate('/my-chats');
    googleAnalyticsInstance.eventGoogleAnalytics({
      category: 'myChat',
      action: 'رو چت من در هدر کلیک شد',
    });
  };

  return (
    <div
      className={`relative cursor-pointer ${className}`}
      onClick={handleClick}
    >
      {hasUnseenMessages && (
        <div className="h-[12px] flex items-center justify-center w-[12px] absolute text-white text-[10px] rounded-full bg-red-700 -right-[2px] -top-[2px] leading-none">
          {unSeenNotificationData.unseen_count > 99
            ? '99+'
            : unSeenNotificationData.unseen_count}
        </div>
      )}
      <i className={iconClass} />
    </div>
  );
};

export default ChatHeaderIcon;
